import { setupI18n } from '@lingui/core';
import { getLocale } from './utils';

export default function i18nSetup(catalogs, localeOverride) {
    // get locale from query parameter, default to en
    const locale = localeOverride || getLocale() || 'en';
    return setupI18n({
        language: locale,
        catalogs
    });
}



// WEBPACK FOOTER //
// ./helpers/locale.js